import React, { Component } from 'react'
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import $ from 'jquery';
import moment from 'moment';
import 'moment/locale/pt-br';
import {
    Calendar,
    momentLocalizer
} from 'react-big-calendar'

moment.locale('pt-br');
const localizer = momentLocalizer(moment);

const months = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
];

export const eventColors = {
    disponivel: 'green',
    naoDisponivel: 'white',
    bloqueado: 'red',
    comAgendamento: 'blue'
}

// Função para personalizar o estilo do evento
const eventStyleGetter = (event, start, end, isSelected) => {
    const eventType = event.tipo || 'naoDisponivel';

    return {
        style: {
            backgroundColor: eventColors[eventType] || 'white',
            borderRadius: '3px',
            opacity: isSelected ? 0.8 : 1,
            color: 'white',
        },
    };
};

export class ModalCalendario extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedYear: new Date().getFullYear(),
        }
    }

    setSelectedYear(year) {
        this.setState({
            selectedYear: year
        })
    }

    limparFormulario() {
        this.props.reset('formularioModalCalendario');
    }

    fecharModal() {
        $('#modalCalendario')
            .modal('hide');
        $('#modalCalendario')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.limparFormulario();
    }

    render() {
        return (
            <div className="modal fade show" id='modalCalendario' role='dialog'
                aria-labelledby='modalCalendario' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>Calendário Disponibilidade Veículo {this.props.agrupadoDisponibilidadeVeiculoSelecionado.veiculo.descricao}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                onClick={this.limparFormulario.bind(this)}>
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className='calendario'>
                                <div>
                                    <div className='calendario-legend calendario-legend-verde'> </div> <span className='calendario-legend-texto'>Disponível</span>
                                </div> 
                                <div>
                                    <div className='calendario-legend calendario-legend-vermelho'> </div> <span className='calendario-legend-texto'>Bloqueado</span>
                                </div>
                                <div>
                                    <div className='calendario-legend calendario-legend-branco'> </div> <span className='calendario-legend-texto'>não disponível</span>
                                </div> 
                                <div>
                                    <div className='calendario-legend calendario-legend-azul'> </div> <span className='calendario-legend-texto'>Com agendamento</span>
                                </div>
                            </div>
                            <div className="row justify-content-center mt-4">
                                {months.map((month, index) => (
                                    <div key={`calendario-${index}`} className='col-12 col-sm-6 col-md-6'>
                                        <div className='mb-4'>
                                            <h2>{month}</h2>
                                            <div style={{ height: '400px' }}>
                                                <Calendar
                                                    localizer={localizer}
                                                    events={this.props.combinedEventsData}
                                                    tooltipAccessor="legenda"
                                                    startAccessor="start"
                                                    endAccessor="end"
                                                    defaultView="month"
                                                    views={['month']}
                                                    date={new Date(this.state.selectedYear, index, 1)}
                                                    eventPropGetter={eventStyleGetter}
                                                    onNavigate={(date) => this.setSelectedYear(date.getFullYear())}
                                                    components={{
                                                        toolbar: () => null
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export const mapStateToProps = state => {

    return {
        empresaSelecionada: state.empresaSelecionada,
        agrupadoDisponibilidadeVeiculoSelecionado: state.agrupadoDisponibilidadeVeiculoSelecionado
    }
};

export default connect(mapStateToProps, {})(reduxForm({
    form: 'formularioModalCalendario',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalCalendario));